import ExploreOtherCategories from "./ExploreOtherCategories";
export default ExploreOtherCategories;
